import $ from 'jquery';

const topShow = 1200; // В каком положении полосы прокрутки начинать показ кнопки "Наверх"
const delay = 600; // Задержка прокрутки
const buttonScroll = $('.button-scroll-top');

buttonScroll.hide();

$(window).scroll(() => {
    if ($(window).scrollTop() > topShow) { buttonScroll.fadeIn(); } else buttonScroll.fadeOut();
});

buttonScroll.click(() => {
    $('body, html').animate({
        scrollTop: 0,
    }, delay);
});
